import { Button, Input } from "@chakra-ui/react";
import styled from "@emotion/styled";
import MDEditor from "@uiw/react-md-editor";
import { addDoc, collection } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../firebaseConfig";
import ImageUpload from "./ImageUpload";

const BlogAdd = () => {
  const [value, setValue] = useState();
  const [title, setTitle] = useState("");
  const [shortDec, setShortDec] = useState("");
  const [image, setImage] = useState("");
  const [tags, setTags] = useState("");
  const [content, setContent] = useState("");

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const postsCollection = collection(db, "Blog");
    await addDoc(postsCollection, {
      title,
      content: value,
      image,
      tags,
      shortDec,
      createdAt: new Date(),
    });
    alert("Data add Success Fully");
    setTitle("");
    setContent("");
    setShortDec("");
    setImage("");
    setTags("");
  };

  return (
    <Div>
      <div data-color-mode="light">
        <Input
          placeholder="Title"
          mb={2}
          onChange={(e) => setTitle(e.target.value)}
        />
        <Input
          placeholder="Short description"
          mb={2}
          onChange={(e) => setShortDec(e.target.value)}
        />
        <Input
          placeholder="Header image"
          mb={2}
          onChange={(e) => setImage(e.target.value)}
        />
        <Input
          placeholder="Tags (please put in , separated)"
          mb={2}
          onChange={(e) => setTags(e.target.value)}
        />
        <ImageUpload/>
        <MDEditor
          height={400}
          value={value}
          onChange={(val: any) => {
            setValue(val!);
          }}
        />
        <Button onClick={handleSubmit}>Submit</Button>
      </div>
    </Div>
  );
};

export default BlogAdd;

const Div = styled.div`
  padding: 5%;
`;
